module.exports = __webpack_public_path__ + "img/artisprecsuzannu_logo.bc0dec2c.png";